import React, { useEffect, useState } from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { CustomScrollbar } from "../customScrollbar/CustomScrollbar";
import { DatePicker } from "@mui/lab";

import SearchIcon from "@mui/icons-material/Search";
import ClearAllIcon from "@mui/icons-material/ClearAll";

const Filters = ({ anchorEl, handleClose, type, onFilterChange }) => {
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const popoverWidth = anchorEl ? anchorEl.offsetWidth : undefined;

  const initialState = {
    products: {
      productType: "",
      country: "",
      code: "",
      title: "",
      points: "",
      prefixCode: "",
    },
    missions: {
      code: "",
      startDate: "",
      endDate: "",
      extraPointType: "",
      completed: false,
      enabled: true,
    },
    vouchersqr: {
      associatedDate: "",
      burnDate: "",
      code: "",
      material: "",
      serialNumber: "",
      associated: false,
      notAssociated: false,
      sentToSap: false,
      sentToSF: false,
      sentPromotionToSF: false,
    },
    vouchersint: {
      associatedDate: "",
      promoAssociatedDate: "",
      burnDate: "",
      ofrCode: "",
      associated: false,
      notAssociated: false,
      sentToSap: false,
      sentToSF: false,
      sentPromotionToSF: false,
    },
    vouchersext: {
      associatedDate: "",
      code: "",
      associated: false,
      notAssociated: false,
    },
    promoprefixes: {
      code: "",
      productCode: "",
    },
  };

  const [filters, setFilters] = useState(initialState);

  const handleInputChange = (event, type) => {
    const { name, value } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [type]: {
        ...prevFilters[type],
        [name]: value,
      },
    }));
  };

  const handleCheckboxChange = (event, type) => {
    const { name, checked } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [type]: {
        ...prevFilters[type],
        [name]: checked,
      },
    }));
  };

  const resetFilters = () => {
    setFilters(initialState);
  };

  const applyFilters = () => {
    onFilterChange(filters[type], type);
    handleClose();
  };

  const renderFilters = (type) => {
    const filtersAvailable = Object.keys(initialState[type]).length > 0;

    if (!filtersAvailable) {
      return (
        <Typography sx={{ p: 2 }}>
          No filters are currently available
        </Typography>
      );
    }

    return (
      <CustomScrollbar>
        <Box mx={"2em"} my={"2em"}>
          <Grid2 container spacing={2}>
            {Object.keys(initialState[type]).map((key) => (
              <Grid2 item xs={12} md={6} key={key}>
                {typeof initialState[type][key] === "boolean" ? (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={filters[type][key]}
                        onChange={(event) => handleCheckboxChange(event, type)}
                        name={key}
                      />
                    }
                    label={key}
                  />
                ) : key === "burnDate" ||
                  key === "promoAssociatedDate" ||
                  key === "associatedDate" ||
                  key === "startDate" ||
                  key === "endDate" ? (
                  <>
                    <TextField
                      type="date"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      label={key}
                      variant="outlined"
                      size="small"
                      value={filters[type][key]}
                      onChange={(event) => handleInputChange(event, type)}
                      name={key}
                      sx={{ mb: 1 }}
                    />
                    <DatePicker />
                  </>
                ) : (
                  <TextField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label={key}
                    variant="outlined"
                    size="small"
                    value={filters[type][key]}
                    onChange={(event) => handleInputChange(event, type)}
                    name={key}
                    sx={{ mb: 1 }}
                  />
                )}
              </Grid2>
            ))}
          </Grid2>
        </Box>
      </CustomScrollbar>
    );
  };

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      elevation={1}
      sx={{
        marginTop: "1px",
        "& .MuiPopover-paper": {
          width: popoverWidth,
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: "rgba(12, 55, 89, 0.06)",
          width: "100%",
          height: "300px",
          display: "flex",
          padding: "5px",
          flexDirection: "column",
          position: "relative",
          zIndex: 1,
        }}
      >
        {renderFilters(type)}
      </Box>
      <Box
        width="100%"
        display="flex"
        flexDirection="row-reverse"
        p="6px"
        backgroundColor="rgba(12, 55, 89, 0.15)"
      >
        <Button
          onClick={applyFilters}
          elevation={0}
          variant="contained"
          startIcon={<SearchIcon />}
          sx={{ marginLeft: "5px" }}
        >
          Search
        </Button>
        <Button
          onClick={resetFilters}
          variant="secondary"
          startIcon={<ClearAllIcon />}
        >
          Clear
        </Button>
      </Box>
    </Popover>
  );
};

export default Filters;
